// extracted by mini-css-extract-plugin
export default {"box":"wjGBE9h7maVaQeNqtrJ_"};